import api from "./client";

export const authApi = {
  login: (username, password) => api.post("/auth/login", { username, password }).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
};

export const occupantsApi = {
  list: (q = "") => api.get("/occupants", { params: q ? { q } : {} }).then((r) => r.data),
  create: (data) => api.post("/occupants", data).then((r) => r.data),
  update: (id, data) => api.put(`/occupants/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/occupants/${id}`).then((r) => r.data),
};

export const packagesApi = {
  list: (params = {}) => api.get("/packages", { params }).then((r) => r.data),
  get: (id) => api.get(`/packages/${id}`).then((r) => r.data),
  create: (data) => api.post("/packages", data).then((r) => r.data),
  deliver: (id, data) => api.patch(`/packages/${id}/deliver`, data).then((r) => r.data),
  resend: (id) => api.post(`/packages/${id}/resend`).then((r) => r.data),
};

export const usersApi = {
  list: () => api.get("/users").then((r) => r.data),
  create: (data) => api.post("/users", data).then((r) => r.data),
  update: (id, data) => api.put(`/users/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/users/${id}`).then((r) => r.data),
};

export const settingsApi = {
  get: () => api.get("/settings").then((r) => r.data),
  getPublic: () => api.get("/settings/public").then((r) => r.data),
  update: (data) => api.put("/settings", data).then((r) => r.data),
};

export const auditApi = {
  listLogins: (page = 1, pageSize = 20) =>
    api.get("/audit/logins", { params: { page, pageSize } }).then((r) => r.data),
};

export const areasApi = {
  list: () => api.get("/areas").then((r) => r.data),
  create: (data) => api.post("/areas", data).then((r) => r.data),
  update: (id, data) => api.put(`/areas/${id}`, data).then((r) => r.data),
};

export const bookingsApi = {
  list: (params = {}) => api.get("/bookings", { params }).then((r) => r.data),
  create: (data) => api.post("/bookings", data).then((r) => r.data),
  update: (id, data) => api.put(`/bookings/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/bookings/${id}`).then((r) => r.data),
};

export const visitsApi = {
  listActive: () => api.get("/visits/active").then((r) => r.data),
  listHistory: (params = {}) => api.get("/visits", { params }).then((r) => r.data),
  create: (data) => api.post("/visits", data).then((r) => r.data),
  registerExit: (id, data) => api.patch(`/visits/${id}/exit`, data).then((r) => r.data),
};
